import { createFileRoute } from "@tanstack/react-router";
import { AdminTargetCitiesLayout } from "@/components/admin/pages/AdminTargetCitiesLayout";

export const Route = createFileRoute("/pulse-ops-x7k2/target-cities")({
  component: AdminTargetCitiesLayout,
});
